// extracted by mini-css-extract-plugin
module.exports = {"ok":"StartCourseDialog_ok__Xt5Wu"};